import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b43af9e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-label" }

import TextLabel from "@/components/UI/TextLabel.vue";
interface Props {
	instructions?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'InputLabel',
  props: {
    instructions: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createVNode(TextLabel, { instructions: _ctx.instructions }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["instructions"])
  ]))
}
}

})